import { Link, useNavigate } from "react-router-dom";
import { LogoFull } from "./Logo";
import { Button } from "./Button";
import { BrandFooter } from "./Footer";
import { useAuth } from "../../auth/AuthContext";

export function AppShell({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const onLogout = async () => {
    await logout();
    navigate("/login", { replace: true });
  };

  return (
    <div className="flex min-h-screen flex-col bg-brand-bg text-brand-text">
      <header
        data-testid="app-header"
        className="border-b border-brand-text/10 bg-brand-bg/80 backdrop-blur-sm"
      >
        <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-4">
          <Link to="/dashboard" data-testid="header-logo-link" className="flex items-center">
            <LogoFull className="h-9 w-auto" />
          </Link>
          {user && (
            <div className="flex items-center gap-4">
              <div className="hidden text-right sm:block">
                <p data-testid="header-user-name" className="text-sm font-medium text-brand-text">
                  {user.name}
                </p>
                <p className="text-xs uppercase tracking-widest text-brand-gold">
                  {user.role.replace("_", " ")}
                </p>
              </div>
              {user.picture ? (
                <img
                  src={user.picture}
                  alt=""
                  className="h-10 w-10 rounded-full border border-brand-gold/40 object-cover"
                />
              ) : (
                <div className="flex h-10 w-10 items-center justify-center rounded-full border border-brand-gold/40 bg-brand-surface text-sm text-brand-gold">
                  {user.name?.[0]?.toUpperCase() ?? "?"}
                </div>
              )}
              <Button
                data-testid="logout-button"
                variant="ghost"
                size="sm"
                onClick={onLogout}
              >
                Sign out
              </Button>
            </div>
          )}
        </div>
      </header>
      <main className="flex-1 bg-radial-gold">{children}</main>
      <BrandFooter />
    </div>
  );
}
